import { render, staticRenderFns } from "./UpdateCustomerAccountLimitRequestPopUp.vue?vue&type=template&id=53519406&scoped=true&"
import script from "./UpdateCustomerAccountLimitRequestPopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateCustomerAccountLimitRequestPopUp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCustomerAccountLimitRequestPopUp.vue?vue&type=style&index=0&id=53519406&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53519406",
  null
  
)

export default component.exports